/**
 * AWS console deep links for a Glue job. Region always comes from the
 * job's own `aws_region` - never hardcoded, since the page must not assume
 * every job runs in the same region as the one it happens to load from.
 */
export function buildGlueStudioUrl(jobName: string, awsRegion: string): string {
  return (
    `https://${awsRegion}.console.aws.amazon.com/gluestudio/home` +
    `?region=${awsRegion}#/editor/job/${encodeURIComponent(jobName)}/runs`
  )
}

/**
 * Deep-links to the shared log group with the Glue jobs' own output, not a
 * specific run's log stream - the wire contract carries no run id to build a
 * per-run link from. Linking the exact run's stream is a possible follow-up
 * once that id is available on `TJobSummaryDto`.
 */
export function buildCloudWatchLogsUrl(awsRegion: string): string {
  return (
    `https://${awsRegion}.console.aws.amazon.com/cloudwatch/home` +
    `?region=${awsRegion}#logsV2:log-groups/log-group/$252Faws-glue$252Fquiet$252Foutput`
  )
}
